import { render, staticRenderFns } from "./LatestTransactionsTable.vue?vue&type=template&id=0065594c&scoped=true"
import script from "./LatestTransactionsTable.vue?vue&type=script&lang=js"
export * from "./LatestTransactionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065594c",
  null
  
)

export default component.exports